import { SafetyException } from './Types'

export class SafetyMessage {
    private _type: SafetyException
    private _title: string
    private _msg: string

    constructor(data: string) {
        const msg = JSON.parse(data)
        this._type = msg.ExceptionType
        this._title = msg.title
        this._msg = msg.message
    }

    get type(): SafetyException {
        return this._type
    }

    get title(): string {
        return this._title
    }

    get message(): string {
        return this._msg
    }
}